package module.home

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 24.10.22
 * Author : mariorosshirt
 */
data class SliderObject(
    var mIndicatorIcon: String,
    var mSliderImage: String,
    var mSliderIterator: Int
)
